export interface IAdsStrings {
    page: IAdsPageStrings
    statement: ISubscriptionStatementStrings;
    creation: IAdsCreation;
    list: IAdsList;
}
export interface ISubscriptionStatementStrings {
    amount: string;
    discount: string;
    expires_label: string;
    modal_plans_title: string;
    modal_payment_title: string;
    nps: {
        subscribe_cancelment: string;
    };
    payment_method: string;
    plan: string;
    status: {
        WAITING: SubscriptionsStatementStrings;
        ACTIVATED: SubscriptionsStatementStrings;
        CANCELLED: SubscriptionsStatementStrings;
    };
    title: string;
}

export interface SubscriptionsStatementStrings {
    title: string;
    badge_style: string;
    button_label?: string;
    cancel_button_label?: string | null;
    download_button_label?: string | null;
    modal_title?: string | null;
    modal_description?: string | null;
    modal_button_cancel_label?: string | null;
    modal_button_confirm_label?: string | null;
    dropdown?: {
        item1: {
            description: string;
        }
    }
}

export interface IAdsCreation {
    form: {
        title: string;
        subtitle: string;
        description: {
            label: string;
            placeholder: string;
            help_block: string;
        }
        product: {
            label: string;
            placeholder: string;
            help_block: string;
        }
        showDescription: {
            label: string;
        }
        images: {
            title: string;
            label: string;
        }
        actions: {
            updated: string;
            created: string;
            deleted: string;
        }
    }
}

export interface IAdsList {
    title: string;
    deleted: string;
    due_date_label: string;
    delete_modal: {
        title: string;
        description: string;
        buttons: {
            cancel: string;
            proceed: string;
        }
    }
}

export interface IAdsPageStrings {
    description: string;
    plans: {
        home_ads: {
            title: string;
            label: string;
            summary: string;
            description: string;
        };
    };
    title: string;
    subscribe_button: {
        label: string;
    }
};

export const AdsStrings: {
    PTBR: IAdsStrings
} = {
    PTBR: {
        page: {
            description: `Assinando o plano de publicidade você poderá anunciar imagens mais chamativas para seus produtos.`,
            plans: {
                home_ads: {
                    title: "Publicidade na Tela Principal",
                    summary: "Sua publicidade visível a todos os visitantes em nossa tela inicial",
                    description: "Sua publicidade visível a todos os visitantes em nossa tela inicial",
                    label: ""
                },
            },
            title: "Planos de Publicidade",
            subscribe_button: {
                label: "Assine este plano",
            }
        },
        statement: {
            amount: 'Total do plano',
            discount: 'Desconto',
            expires_label: 'Data de Vencimento',
            modal_plans_title: 'Escolha o novo plano',
            modal_payment_title: 'Escolha a forma de pagamento',
            nps: {
                subscribe_cancelment: "Conte-nos o motivo de estar cancelando:",
            },
            payment_method: 'Pagamento',
            plan: 'Plano',
            status: {
                WAITING: {
                    title: 'Aguardando',
                    badge_style: 'warning',
                    cancel_button_label: 'Cancelar',
                    download_button_label: 'Boleto',
                    modal_title: "Troca de Plano",
                    modal_description: "Você está decidindo cancelar seu pedido de troca de plano.",
                    modal_button_cancel_label: "NÃO, foi sem querer",
                    modal_button_confirm_label: "SIM, pode cancelar"
                },
                ACTIVATED: {
                    title: "Ativo",
                    badge_style: "success",
                    button_label: 'Mudar de plano',
                    modal_title: "Cancelamento de Assinatura",
                    modal_description: "Cuidado, se você continuar a sua inscrição ativa será cancelada e você perderá o acesso à plataforma de anúncios.",
                    modal_button_cancel_label: "NÃO, foi sem querer",
                    modal_button_confirm_label: "SIM, pode cancelar",
                    dropdown: {
                        item1: {
                            description: "Cancelar Assinatura"
                        }
                    }
                },
                CANCELLED: {
                    title: "Cancelado",
                    badge_style: "danger",
                },
            },
            title: 'Extrato de Publicidades'
        },
        creation: {
            form: {
                title: "Criar Publicidade",
                subtitle: "Sobre a publicidade",
                description: {
                    label: "Descrição",
                    placeholder: "Texto que será mostrado junto com o anúncio",
                    help_block: "Neste campo você informa, uma descrição para a banner. Ao concluir pressione TAB para continuar.",
                },
                product: {
                    label: "Produto",
                    placeholder: "Selecione um produto",
                    help_block: "Produto que será exibido se o usuário clicar no seu banner"
                },
                showDescription: {
                    label: "Mostrar a descrição junto com o banner"
                },
                actions: {
                    updated: "Banner atualizado com sucesso!",
                    created: "Banner cadastrado com sucesso!",
                    deleted: "Banner removido com sucesso!",
                },
                images: {
                    title: "Imagens",
                    label: "Escolha imagens (JPG, PNG, JFIF, WEBP)"
                }
            },
        },
        list: {
            title: "Banners Cadastrados",
            deleted: "Banners removido com sucesso",
            due_date_label: "Expira em",
            delete_modal: {
                title: "Excluir Publicidade",
                description: "Se você continuar esta publicidade será excluída DEFINITIVAMENTE.<br />Tem certeza que deseja continuar?",
                buttons: {
                    cancel: "Não, foi engano!",
                    proceed: "Sim, pode excluir"
                }
            }
        }
    },
};